

global.NotesAndCoins = (function ($) {

	var frontImage = $('.js-notes-coins-front-image');
	var backImage = $('.js-notes-coins-back-image');

	var showFrontImageBtn = $('.js-show-front-image');
	var showBackImageBtn = $('.js-show-back-image');

	var showSecurityDetailsBtn = $('.js-show-security-details');
	var showMotifDetailsBtn = $('.js-show-motif-details');

	var securityFront = $('.js-show-security-front');
	var securityBack = $('.js-show-security-back');
	var motifFront = $('.js-show-motif-front');
	var motifBack = $('.js-show-motif-back');

	var securityContentDetailsFront = $('.js-show-security-details-front');
	var securityContentDetailsBack = $('.js-show-security-details-back');
	var motifContentDetailsFront = $('.js-show-motif-details-front');
	var motifContentDetailsBack = $('.js-show-motif-details-back');

	var isFrontImage = true;
	var isSecurityDetails = true;

	function init() {

		frontImage.show();
		securityFront.show();
		securityContentDetailsFront.show();

		moveDetailTexts();

		showBackImageBtn.on('click', function () {
			showBackImageBtn.addClass('active');
			showBackImageBtn.attr('aria-pressed', 'true');
			showFrontImageBtn.removeClass('active');
			showFrontImageBtn.attr('aria-pressed', 'false');

			if (isFrontImage) {
				flipImage(isFrontImage);
			}
			isFrontImage = false;
		});

		showFrontImageBtn.on('click', function () {
			showFrontImageBtn.addClass('active');
			showFrontImageBtn.attr('aria-pressed', 'true');
			showBackImageBtn.removeClass('active');
			showBackImageBtn.attr('aria-pressed', 'false');

			if (!isFrontImage) {
				flipImage(isFrontImage);
			}
			isFrontImage = true;
		});

		showSecurityDetailsBtn.on('click', function () {

			showSecurityDetailsBtn.addClass('active');
			showSecurityDetailsBtn.attr('aria-pressed', 'true');
			showMotifDetailsBtn.removeClass('active');
			showMotifDetailsBtn.attr('aria-pressed', 'false');

			isSecurityDetails = true;

			if (isFrontImage) {
				showSecurityFront();
			}
			else {
				showSecurityBack();
			}
		});

		showMotifDetailsBtn.on('click', function () {

			showMotifDetailsBtn.addClass('active');
			showMotifDetailsBtn.attr('aria-pressed', 'true');

			showSecurityDetailsBtn.removeClass('active');
			showSecurityDetailsBtn.attr('aria-pressed', 'false');

			isSecurityDetails = false;

			if (isFrontImage) {
				showMotifFront();
			}
			else {
				showMotifBack();
			}
		});
	}

    function flipImage() {

    	if (isFrontImage) {
    		frontImage.hide();
    		backImage.show();

    		if (isSecurityDetails) {
    			showSecurityBack();
    		}
    		else {
    			showMotifBack();
    		}
    	}
    	else {
    		backImage.hide();
    		frontImage.show();
    		showSecurityFront();

    		if (isSecurityDetails) {
    			showSecurityFront();
    		}
    		else {
    			showMotifFront();
    		}
    	}
    }

    function hideAllDetails() {
    	securityBack.hide();
    	securityFront.hide();
    	motifBack.hide();
    	motifFront.hide();
    	securityContentDetailsFront.hide();
    	securityContentDetailsBack.hide();
    	motifContentDetailsFront.hide();
    	motifContentDetailsBack.hide();
    }

    function showSecurityFront() {
    	hideAllDetails();

    	securityFront.show();
    	securityContentDetailsFront.show();
    }

    function showSecurityBack() {
    	hideAllDetails();

    	securityBack.show();
    	securityContentDetailsBack.show();
    }

    function showMotifFront() {
    	hideAllDetails();

    	motifFront.show();
    	motifContentDetailsFront.show();
    }

    function showMotifBack() {
    	hideAllDetails();

    	motifBack.show();
    	motifContentDetailsBack.show();
    }

    function moveDetailTexts() {
    }

    return {
        init: init
    };
})(jQuery);
